module.exports = __webpack_public_path__ + "img/sweet_potato.7175442c.jpg";